/* unplugin-vue-components disabled */import { render } from "./popupAgreetContent.vue?vue&type=template&id=a66990e2&scoped=true"
import script from "./popupAgreetContent.vue?vue&type=script&lang=js"
export * from "./popupAgreetContent.vue?vue&type=script&lang=js"

import "./popupAgreetContent.vue?vue&type=style&index=0&id=a66990e2&scoped=true&lang=css"

import exportComponent from "/Users/huangzhichao/Code/beyoung/weitu_land_page_h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a66990e2"]])

export default __exports__